import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import Slider from 'react-slick';
import useDefaultCallToAction from 'hooks/useDefaultCallToAction';
import WebsiteImage from 'components/WebsiteImage';
import getBreakpointView from 'utils/getBreakpointView';
import { STIcon } from 'components/Brand/Icons/STIcon';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';
import { truncateText } from 'utils/text';
import WistiaVideo from 'components/Core/WistiaVideo';
import { SectionSoftware } from './styles';
import MobileCarousel from '../MobileCarousel';

const InPageFeaturesV2 = ({
  cta,
  title,
  description,
  inPageNavigationItems,
  backgroundColor,
  bg,
  ...otherProps
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const isMobile = getBreakpointView(['xs', 'sm', 'md']);
  const callToAction = cta || useDefaultCallToAction();

  let slider;
  const sliderSettings = {
    animation: false,
    dots: false,
    arrows: true,
    infinite: true,
    draggable: false,
    touchMove: false,
    speed: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    accessibility: false,
    cssEase: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    afterChange: index => {
      setSelectedIndex(index);
    },
  };

  const onNavItemClick = index => {
    if (index >= 0) {
      setSelectedIndex(index);
      slider.slickGoTo(index, true);
    }
  };

  const hasNavigation = !isNil(inPageNavigationItems[selectedIndex]);

  let selNavOffsetTop = 0;
  let selObj = null;
  if (
    typeof window === 'object' &&
    (selObj = document.getElementById(`section-software--navigation-item--${selectedIndex}`))
  ) {
    selNavOffsetTop = selObj.offsetTop;
  }

  return (
    <SectionSoftware
      background={backgroundColor}
      className="in-page-features-v2--container"
      id="in-page-features-v2"
    >
      <div className="section-software--container">
        <div className="section-software--header-container">
          <h2 className="section-software--title">{title}</h2>
          <p className="section-software--description">{description}</p>
        </div>

        {!isMobile ? (
          <div className="section-software--content-container">
            <div className="section-software--navigation-content">
              {inPageNavigationItems.map((item, index) => {
                return (
                  <div
                    className={
                      'section-software--navigation-item' +
                      (index === selectedIndex ? ' selected-item' : '')
                    }
                    id={`section-software--navigation-item--${index}`}
                    onClick={() => onNavItemClick(index)}
                    key={index}
                  >
                    <h2 className="section-software--navigation-item-title">{item.title}</h2>
                  </div>
                );
              })}

              <ContentfulCallToAction
                {...callToAction}
                buttonClass="section-software--navigation-cta"
              />

              <STIcon
                className="section-software--navigation-item-arrow"
                type="icon-selected"
                style={{ top: -4 + selNavOffsetTop }}
              />
            </div>

            <div className="section-software--content-content">
              <Slider ref={c => (slider = c)} {...sliderSettings}>
                {inPageNavigationItems.map((item, index) => {
                  const { featuredImage, featuredVideo } = item;

                  return (
                    <div className="section-software--main-content" key={index}>
                      {featuredImage && (
                        <div className="section-software--image-content">
                          <WebsiteImage {...featuredImage} fullResolution />
                        </div>
                      )}
                      {featuredVideo && (
                        <div className="section-software--video-content">
                          <WistiaVideo dataPosition="In-Page Features" {...featuredVideo} />
                        </div>
                      )}
                      <div className="section-software--description-content">
                        {hasNavigation && item.description && (
                          <div className="section-software--description-content-container">
                            <p>
                              {truncateText(
                                item.description?.json?.content[0]?.content[0]?.value,
                                206
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        ) : (
          <MobileCarousel
            inPageNavigation={inPageNavigationItems}
            backgroundColor={backgroundColor}
          />
        )}
      </div>
    </SectionSoftware>
  );
};

InPageFeaturesV2.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  inPageNavigationItems: PropTypes.array,
};

InPageFeaturesV2.defaultProps = {
  backgroundColor: '#f6f8fa',
};

export default InPageFeaturesV2;
